/**
 * 字符串相关工具函数
 */

/**
 * 计算字符串的 UTF-8 字节长度
 *
 * 注意:这个函数和使用 TextEncoder 的结果相同,但提供了一个更显式的实现
 */
export function getUTF8ByteLength(str: string): number {
  // 方法1: 使用 TextEncoder (推荐,现代浏览器都支持)
  return new TextEncoder().encode(str).length

  // 方法2: 手动计算
  // let byteLength = 0
  // for (let i = 0; i < str.length; i++) {
  //   const charCode = str.charCodeAt(i)
  //   if (charCode <= 0x7f) {
  //     byteLength += 1
  //   } else if (charCode <= 0x7ff) {
  //     byteLength += 2
  //   } else if (charCode <= 0xffff) {
  //     byteLength += 3
  //   } else {
  //     byteLength += 4
  //   }
  // }
  // return byteLength
}

/**
 * 文本省略
 */
export function ellipsis(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text
  return text.slice(0, maxLength) + '...'
}

/**
 * 规范化 UUID (转换为小写)
 *
 * 用于统一台桌 UUID 的大小写格式,确保比较时一致性
 *
 * @param uuid - 原始 UUID 字符串
 * @returns 小写的 UUID 字符串
 *
 * @example
 * normalizeUUID('ABC-123-DEF') // 'abc-123-def'
 * normalizeUUID('abc-123-def') // 'abc-123-def'
 */
export function normalizeUUID(uuid: string): string {
  return uuid.toLowerCase()
}

/**
 * 比较两个 UUID 是否相同 (忽略大小写)
 *
 * @param uuid1 - 第一个 UUID
 * @param uuid2 - 第二个 UUID
 * @returns 是否相同
 *
 * @example
 * compareUUID('ABC-123', 'abc-123') // true
 * compareUUID('ABC-123', 'DEF-456') // false
 */
export function compareUUID(uuid1: string, uuid2: string): boolean {
  return normalizeUUID(uuid1) === normalizeUUID(uuid2)
}
